import { render, staticRenderFns } from "./legal-recover-case-manage.vue?vue&type=template&id=0b053bae&scoped=true"
import script from "./legal-recover-case-manage.vue?vue&type=script&lang=ts"
export * from "./legal-recover-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b053bae",
  null
  
)

export default component.exports